export function ThumbDownFillIcon({ size, color = "black", className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.03333 10.8333V3.33332H4.69166C3.94166 3.33332 3.34166 3.93332 3.34166 4.67499V9.48332C3.34166 10.225 3.94999 10.8333 4.69166 10.8333H6.03333ZM15.4167 12.0833H11.4333V15C11.4333 15.9167 10.6833 16.6667 9.77499 16.6667H9.69999C9.36666 16.6667 9.06666 16.4667 8.93333 16.1583L6.65833 10.8333V3.33332H14.325C14.9333 3.33332 15.45 3.76666 15.5583 4.36666L16.6583 10.6167C16.7917 11.3833 16.2083 12.0833 15.425 12.0833H15.4167Z"
        fill="black"
      />
    </svg>
  );
}
